import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useSeo } from "@/hooks/useSeo";
import { CategoryGrid } from "@/components/CategoryGrid";
import { Section } from "@/components/Section";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

export default function ExplorePage() {
  useSeo("Explore Cities & Categories | OyeBest", "Explore all categories and cities on OyeBest.");
  const [categories, setCategories] = useState([]);
  const [cities, setCities] = useState([]);
  const city = localStorage.getItem("oyebest_city") || "etah";

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(r.data));
    api.get("/cities").then((r) => setCities(r.data));
  }, []);

  return (
    <>
      <section className="bg-gradient-to-b from-accent to-white border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight">Explore OyeBest</h1>
          <p className="text-muted-foreground mt-2">Browse all categories and cities available on OyeBest.</p>
        </div>
      </section>

      <Section title="Cities" subtitle="Choose your city">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {cities.map((c) => (
            <Link key={c.slug} to={`/${c.slug}`} className="flex items-center gap-3 p-4 rounded-2xl border border-border/60 bg-white hover:border-primary/40 hover:shadow-md transition-all" data-testid={`explore-city-${c.slug}`}>
              <span className="w-11 h-11 rounded-xl bg-accent text-primary flex items-center justify-center"><MapPin className="w-5 h-5" /></span>
              <div><p className="font-semibold">{c.name}</p><p className="text-xs text-muted-foreground">{c.count} places</p></div>
            </Link>
          ))}
        </div>
      </Section>

      <Section title="All Categories" subtitle="Har zaroorat ke liye, sahi jagah" id="categories">
        <CategoryGrid categories={categories} city={city} />
      </Section>
    </>
  );
}
